import React, { useContext, useEffect, useState } from "react";
import Grid from "@material-ui/core/Grid";
import useStyles from "./styles";
import { __t } from "@core/translation/translation";
import { ColProps_3 } from "@core/utils/ColProps";
import Typography from "@components/Typography";
import trades from "@api/trades";
import { useParams } from "react-router-dom";
import PriceFormat from "@components/PriceFormat";
import { StatsContext } from "@context/statsContext";
import { recentMarketTime } from "@core/utils/IntervalApiTime";
import { useRangerOptional } from "@context/rangerContext";
import { formatDisplayDateTime } from "@core/helper/formatDisplayDateTime";

const titles = [__t("Price"), __t("size"), __t("time")];

const MarketRecentTransactions = ({ ListItemNumber = 8 }) => {
  const classes = useStyles();
  const { currencyName } = useParams();
  const { statsState } = useContext(StatsContext);
  const ranger = useRangerOptional();
  const useWs = Boolean(ranger?.enabled);
  const statItem = statsState?.stats[currencyName?.replace("-", "_")];
  const unitPrice = statItem?.unitPrice;
  const [state, setState] = useState({
    data: [],
    is_fetch: false,
  });

  useEffect(() => {
    if (!useWs || !currencyName || !ranger?.subscribeMarket) return undefined;
    ranger.subscribeMarket(currencyName);
    return () => ranger.unsubscribeMarket?.();
  }, [useWs, currencyName, ranger?.subscribeMarket, ranger?.unsubscribeMarket]);

  useEffect(() => {
    if (useWs && ranger?.connected) {
      setState({ data: ranger.trades || [], is_fetch: true });
      return undefined;
    }

    let timerToClear = null;
    (function fetch() {
      trades
        .getRecentMarkets({
          params: {
            market: currencyName?.replace("-", "_"),
          },
        })
        .then((data) => {
          setState((prevState) => ({
            ...prevState,
            data: data.content,
            is_fetch: true,
          }));
        })
        .catch((data) => {
          console.log(data);
        });

      timerToClear = setTimeout(fetch, recentMarketTime * 1000);
    })();

    return () => clearTimeout(timerToClear);
  }, [currencyName, useWs, ranger?.connected, ranger?.trades]);

  const checkColor = (price) => {
    if (price > unitPrice) {
      return "primary.tint90";
    } else if (price < unitPrice) {
      return "red2.main";
    } else {
      return "";
    }
  };

  return (
    <Grid container direction="column" className={classes.root} spacing={5}>
      <Grid item>
        <Typography color="secondary.main" isBold variant="3xs">
          {__t("Recent Transactions")}
        </Typography>
      </Grid>

      <Grid
        item
        container
        direction="column"
        className={classes.container}
        spacing={2}
      >
        <Grid item container direction="row">
          {titles.map((title) => (
            <Grid item {...ColProps_3} container justify="center" key={title}>
              <Typography variant="3xs" color="secondary.tint100">
                {title}
              </Typography>
            </Grid>
          ))}
        </Grid>

        <Grid
          item
          container
          direction="column"
          className={classes.listItemContainer}
          style={{ minHeight: `calc(${ListItemNumber * 22}px)` }}
        >
          {state?.is_fetch &&
            state?.data?.map(
              (item, index) =>
                index < ListItemNumber && (
                  <div key={item.id || `${item.time}-${index}`}>
                    <Grid
                      item
                      container
                      direction="row"
                      className={classes.listItem}
                    >
                      <Grid item {...ColProps_3} container justify="center">
                        <Typography
                          variant="3xs"
                          isBold
                          color={checkColor(item.amount)}
                        >
                          <PriceFormat price={item.unitPrice} />
                        </Typography>
                      </Grid>
                      <Grid item {...ColProps_3} container justify="center">
                        <Typography
                          variant="3xs"
                          isBold
                          color={checkColor(item.amount)}
                        >
                          <PriceFormat price={item.amount} />
                        </Typography>
                      </Grid>
                      <Grid item {...ColProps_3} container justify="center">
                        <Typography
                          variant="3xs"
                          isBold
                          color="secondary.tint60"
                        >
                          {formatDisplayDateTime(item.time, { pattern: "time", input: "unixSec" })}
                        </Typography>
                      </Grid>
                    </Grid>
                  </div>
                )
            )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default MarketRecentTransactions;
